import { decryptData, encryptData } from "config/config";
import { instance as axios } from "config/axiosInstance";
import { isLoggedIn } from "utils";

// *********************************** Category List ***********************************************
export const getCategoryList = async (data) => {
  return decryptData(
    await axios.get(
      `/getCategoryList?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

export const addCategory = async (data) => {
  return decryptData(
    await axios.post(`/addCategory`, {
      reqData: encryptData({
        ...data,
        access_token: isLoggedIn(),
      }),
    })
  );
};

export const getCategoryByID = async (data) => {
  return decryptData(
    await axios.get(
      `/getCategoryByID?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

export const updateCategory = async (data) => {
  return decryptData(
    await axios.post(`/updateCategory`, {
      reqData: encryptData({
        ...data,
        access_token: isLoggedIn(),
      }),
    })
  );
};

export const updateStatusOfCategory = async (data) => {
  return decryptData(
    await axios.post(`/updateStatusOfCategory`, {
      reqData: encryptData({
        ...data,
        access_token: isLoggedIn(),
      }),
    })
  );
};

